import React from "react";
import { problems } from "../mock";
import Reveal from "./Reveal";

export default function Problem() {
  return (
    <section className="relative py-24 md:py-32 bg-[#f7f3ea]">
      <div className="max-w-7xl mx-auto px-6">
        <Reveal>
          <div className="max-w-3xl mb-16">
            <p className="font-mono-eyebrow text-[#486a8f] mb-4">The problem</p>
            <h2 className="font-display text-[40px] md:text-[56px] leading-[1.05] text-[#0f1724] tracking-tight">
              Personal growth is hard when you're{" "}
              <span className="italic font-light text-[#486a8f]">doing it alone</span>
            </h2>
          </div>
        </Reveal>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8">
          {problems.map((p, i) => (
            <Reveal key={p.title} delay={i * 0.12}>
              <div className="h-full rounded-2xl bg-white border border-[#eadfc9] p-10 card-hover">
                <div className="w-14 h-14 rounded-xl bg-[#f2ecdc] flex items-center justify-center mb-6 border border-[#e6dcc6]">
                  <span className="font-display text-[26px] text-[#486a8f]">{p.symbol}</span>
                </div>
                <h3 className="font-display text-[24px] md:text-[26px] text-[#0f1724] tracking-tight mb-3 leading-tight">
                  {p.title}
                </h3>
                <p className="font-body text-[15px] leading-relaxed text-[#4b5563]">
                  {p.description}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
